import { reinviteDirector } from './states';

export const services = {
  reinviteDirector,
};
